/**
 * Identity of the API contract this build was generated from (hash of
 * Infrastructure/Api/swagger.json, injected by `define` in vite.config.ts).
 * Used as the `buster` of the persisted React Query cache: when it changes,
 * `persistQueryClient` throws away everything persisted by the previous build,
 * so a DTO shape change can never be rendered from stale localStorage data.
 * Falls back to a constant outside Vite (vitest).
 */
export const API_CONTRACT_ID: string =
	typeof __API_CONTRACT_ID__ === "string" && __API_CONTRACT_ID__ !== ""
		? __API_CONTRACT_ID__
		: "dev";
